import { cloneElement } from 'react';
import type { CommonProps } from '@/@types/common';

const AuthLayout = ({ children, ...rest }: CommonProps) => {
  return (
    <div className="flex h-lvh bg-white p-6 dark:bg-gray-800">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="w-full max-w-[380px] px-8 xl:max-w-[450px]">
          {children
            ? cloneElement(children as React.ReactElement, {
                ...rest,
              })
            : null}
        </div>
      </div>
      <div className="relative hidden max-w-[520px] flex-1 flex-col items-end justify-between rounded-3xl px-10 py-6 lg:flex 2xl:max-w-[720px]">
        <img
          src="/img/auth-side-bg.png"
          className="absolute top-0 left-0 h-full w-full rounded-3xl"
          alt="Auth Side BG"
        />
      </div>
    </div>
  );
};

export default AuthLayout;
